import React from 'react';
import { useTranslation } from 'react-i18next';
import { Play } from 'lucide-react';

const getStatusColor = (status) => {
  switch (status) {
    case 'LIVE': return 'bg-emerald-500';
    case 'WATCHDOG': return 'bg-amber-500';
    default: return 'bg-slate-600';
  }
};

const getTypeColor = (type) => {
  switch (type) {
    case 'MASTER': return 'text-purple-400 bg-purple-400/10';
    case 'ARBITRAGE': return 'text-blue-400 bg-blue-400/10';
    case 'ALPHA': return 'text-emerald-400 bg-emerald-400/10';
    case 'QUANT': return 'text-cyan-400 bg-cyan-400/10';
    case 'EXECUTION': return 'text-amber-400 bg-amber-400/10';
    case 'SUPERVIVENCIA': return 'text-rose-400 bg-rose-400/10';
    case 'INTANGIBLE': return 'text-purple-400 bg-purple-400/10';
    default: return 'text-slate-400 bg-slate-400/10';
  }
};

export function AgentCard({ agent, onToggle }) {
  const { t } = useTranslation();
  return (
    <div className="bg-[#090B0F] border border-white/10 p-4 hover:border-white/20 transition-all hover:-translate-y-[1px]"
      data-testid={`agent-card-${agent.id}`}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full animate-pulse ${getStatusColor(agent.status)}`} />
          <span className="font-mono text-xs text-slate-400">{agent.id}</span>
        </div>
        <span className={`text-xs px-2 py-0.5 font-mono ${getTypeColor(agent.type)}`}>{agent.type}</span>
      </div>
      <h4 className="font-bold text-white text-sm mb-1">{agent.name}</h4>
      <p className="text-slate-500 text-xs mb-3 line-clamp-1">{agent.description}</p>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="bg-[#11141D] p-2">
          <p className="text-xs text-slate-500 mb-0.5">P&L</p>
          <p className={`font-mono text-sm ${agent.current_pnl >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
            {agent.current_pnl >= 0 ? '+' : ''}{agent.current_pnl?.toLocaleString()}
          </p>
        </div>
        <div className="bg-[#11141D] p-2">
          <p className="text-xs text-slate-500 mb-0.5">{t('common.return')}</p>
          <p className={`font-mono text-sm ${agent.total_return >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
            {agent.total_return >= 0 ? '+' : ''}{agent.total_return}%
          </p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="text-xs">
          <span className="text-slate-500">Capital: </span>
          <span className="font-mono text-white">${(agent.capital_allocated / 1000).toFixed(0)}K</span>
        </div>
        <button
          onClick={() => onToggle(agent.id, agent.status === 'LIVE' ? 'OFF' : 'LIVE')}
          className={`w-8 h-5 rounded-full transition-colors relative ${agent.status === 'LIVE' ? 'bg-emerald-500' : 'bg-slate-700'}`}
          data-testid={`agent-toggle-switch-${agent.id}`}>
          <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-transform ${agent.status === 'LIVE' ? 'left-3.5' : 'left-0.5'}`} />
        </button>
      </div>
    </div>
  );
}
